import { MouseEvent, useId } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '../../Shared/Button/Button';
import { Spinner } from '../../Shared/Spinner';
import { GoogleIcon } from '../../icons/Google.icon';
import { LastUsedBadge } from '@/Domain/components/Auth/LastUsedBadge';

type Props = {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
  disabled?: boolean;
  isLoading?: boolean;
  isLastUsed?: boolean;
  'data-testid'?: string;
};

export const GoogleButton = ({
  onClick,
  disabled,
  isLoading,
  isLastUsed = false,
  'data-testid': testId,
}: Props) => {
  const { t } = useTranslation(['entry']);
  const badgeId = useId();

  return (
    <div className="relative">
      <Button
        type="button"
        variant="secondary"
        size="lg"
        onClick={onClick}
        disabled={disabled}
        className="w-full min-h-12 h-auto gap-3 font-medium whitespace-normal"
        aria-describedby={isLastUsed ? badgeId : undefined}
        data-testid={testId}
      >
        {isLoading ? <Spinner /> : <GoogleIcon className="h-5 w-5" />}
        <span>{t('continue_with', { value: 'Google' })}</span>
      </Button>
      {isLastUsed && <LastUsedBadge id={badgeId} />}
    </div>
  );
};
